import { render } from "./addPost.vue?vue&type=template&id=9b43bdbe"
import script from "./addPost.vue?vue&type=script&lang=js"
export * from "./addPost.vue?vue&type=script&lang=js"

import "./addPost.vue?vue&type=style&index=0&id=9b43bdbe&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__